import { StyleSheet, View } from 'react-native';
import IconCircleSized from '../../components/IconCircleSized';
import Text from '$tablet-app/src/app/components/Text';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FC } from 'react';

const ChatWidgetHeader: FC<{ icon?: IconProp; header_text: string }> = ({
  icon,
  header_text,
}) => {
  return (
    <View style={styles.header}>
      {icon ? <IconCircleSized size={18} width={34} icon={icon} /> : null}
      <Text style={styles.top_text}>{header_text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingLeft: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottomColor: 'rgba(255, 255, 255, 0.6)',
    borderBottomWidth: 1,
  },
  top_text: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: 13,
    paddingLeft: 10,
    fontStyle: 'normal',
  },
});

export default ChatWidgetHeader;
